import { OrderCommand } from '../../../../services/command';
import { StoreActionType as Type } from '../../types';

export const fetchOrderDetails: any = (orderId: any) => {
    return (dispatch: any) => {
        dispatch({ type: Type.GET_ORDER_DETAILS_REQUEST });

        OrderCommand.GetOrderDetail(orderId)
            .then((res: any) => {
                if (res) {
                    dispatch({ type: Type.GET_ORDER_DETAILS_SUCCESS, payload: res });
                } else {
                    dispatch({ type: Type.GET_ORDER_DETAILS_SUCCESS, payload: [] });
                }
            })
            .catch((error: any) => {
                console.error('Hata:', error);
                dispatch({ type: Type.GET_ORDER_DETAILS_FAILURE, payload: error });
            });
    };
};
